import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { OptionSetsExplorer } from "@/components/cars/OptionSetsExplorer";
import { PageHeader } from "@/components/ui/PageHeader";
import { ExplorerSkeleton } from "@/components/ui/PageSkeleton";
import { useCarOptionSets } from "@/lib/queries";

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
};

export function OptionSetsPage() {
  const { data: optionSets, isLoading, error } = useCarOptionSets();

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
      className="space-y-10"
    >
      <div className="space-y-5">
        <Link
          to="/cars"
          aria-label="Back to cars"
          className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[var(--color-accent)] text-white opacity-100 transition hover:bg-[var(--color-accent-hover)]"
        >
          <ArrowLeft className="h-5 w-5" />
        </Link>

        <PageHeader
          title="Option sets"
          description="Browse and manage vehicle catalogue entries — makes, models, and trims available when users add a car in Shift."
          showGreeting={false}
        />
      </div>

      {isLoading ? (
        <ExplorerSkeleton title="Option sets" />
      ) : error ? (
        <p className="text-sm text-red-600">Failed to load option sets. Please try again.</p>
      ) : (
        <OptionSetsExplorer optionSets={optionSets ?? []} />
      )}
    </motion.div>
  );
}
